export function formatValue(
  value?: number | null,
  precision = 2,
  minDigits = precision
) {
  if (value === undefined || value === null) {
    return "";
  }

  return value.toLocaleString("en-US", {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: precision,
  });
}

export function formatPercentChange(changeValue: number, precision?: number) {
  if (changeValue === undefined || changeValue === null) {
    return "--";
  }

  return `${formatChange(changeValue, precision)}%`;
}

export function formatChange(changeValue: number, precision?: number) {
  if (changeValue === undefined || changeValue === null) {
    return "--";
  }

  if (changeValue <= 0) {
    return formatValue(changeValue, precision).replace("-", "–");
  }

  return `+${formatValue(changeValue, precision)}`;
}
